import React from 'react';
import { Facebook, Youtube, Instagram, Phone, Mail } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-plum py-12 md:py-16 border-t border-cream/10" data-id="element-58">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-59">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8 mb-12" data-id="element-60">
          {/* Brand & Contact Column */}
          <div className="md:col-span-2" data-id="element-61">
            <div className="text-cream font-fraunces text-2xl font-semibold mb-4 flex items-center gap-3" data-id="element-62">
              <svg className="w-8 h-8 text-orange" viewBox="0 0 100 100" fill="currentColor" data-id="element-63">
                <path d="M50 0C50 0 20 30 20 60C20 76.5685 33.4315 90 50 90C66.5685 90 80 76.5685 80 60C80 30 50 0 50 0ZM50 75C41.7157 75 35 68.2843 35 60C35 45 50 25 50 25C50 25 65 45 65 60C65 68.2843 58.2843 75 50 75Z" data-id="element-64" />
              </svg>
              Stela Lucuța
            </div>
            <p className="text-cream/70 text-sm max-w-[400px] leading-relaxed mb-4" data-id="element-65">
              LUCUȚA STELA PERSOANĂ FIZICĂ AUTORIZATĂ
            </p>
            <div className="text-cream/50 text-xs leading-relaxed space-y-1 mb-6" data-id="element-66">
              <p data-id="element-67">Cod fiscal: 41799976</p>
              <p data-id="element-68">Nr. registrul comerțului: F24/1072/2019</p>
              <p data-id="element-69">Str. Vasile Lucaciu, nr. 73, Baia Mare, Jud. Maramureș</p>
            </div>
            <div className="space-y-2" data-id="element-70">
              <a href="tel:+40744377234" className="flex items-center gap-2 text-cream/70 hover:text-cream transition-colors text-sm" data-id="element-71">
                <Phone className="w-4 h-4" strokeWidth={1.5} data-id="element-72" />
                +40 744 377 234
              </a>
              <a href="mailto:stelalucuta@yahoo.com" className="flex items-center gap-2 text-cream/70 hover:text-cream transition-colors text-sm" data-id="element-73">
                <Mail className="w-4 h-4" strokeWidth={1.5} data-id="element-74" />
                stelalucuta@yahoo.com
              </a>
            </div>
          </div>

          {/* Links Column */}
          <div data-id="element-75">
            <h4 className="text-cream font-poppins font-semibold mb-4" data-id="element-76">
              Linkuri Utile
            </h4>
            <ul className="space-y-3" data-id="element-77">
              <li data-id="element-78">
                <a href="#" className="text-cream/70 hover:text-cream transition-colors text-sm" data-id="element-79">
                  Despre Mine
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="text-cream/70 hover:text-cream transition-colors text-sm" data-id="element-81">
                  Programe
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="text-cream/70 hover:text-cream transition-colors text-sm" data-id="element-83">
                  Resurse Gratuite
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="text-cream/70 hover:text-cream transition-colors text-sm" data-id="element-85">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Social Column */}
          <div data-id="element-86">
            <h4 className="text-cream font-poppins font-semibold mb-4" data-id="element-87">
              Urmărește-mă
            </h4>
            <div className="flex gap-3 mb-6" data-id="element-88">
              <a href="https://www.facebook.com/stela.lucuta/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-cream/5 flex items-center justify-center text-cream hover:bg-cream hover:text-plum transition-all" data-id="element-89">
                <Facebook className="w-5 h-5" data-id="element-90" />
              </a>
              <a href="https://www.youtube.com/@stelalucuta7309" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-cream/5 flex items-center justify-center text-cream hover:bg-cream hover:text-plum transition-all" data-id="element-91">
                <Youtube className="w-5 h-5" data-id="element-92" />
              </a>
              <a href="https://www.instagram.com/lucutastela/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-cream/5 flex items-center justify-center text-cream hover:bg-cream hover:text-plum transition-all" data-id="element-93">
                <Instagram className="w-5 h-5" data-id="element-94" />
              </a>
              <a href="https://www.tiktok.com/@stelalucuta" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-cream/5 flex items-center justify-center text-cream hover:bg-cream hover:text-plum transition-all" data-id="element-95">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-96">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.73a8.19 8.19 0 004.76 1.52V6.79a4.84 4.84 0 01-1-.1z" data-id="element-97" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="w-full h-[1px] bg-cream/10 mb-8" data-id="element-98"></div>

        {/* Legal Links */}
        <div className="flex flex-wrap justify-center gap-6 mb-8 text-cream/60 text-xs font-inter" data-id="element-99">
          <a href="#" className="hover:text-cream transition-colors" data-id="element-100">
            Politică de Confidențialitate
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-101">
            Termeni și Condiții
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-102">
            Politică Cookie-uri
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-103">
            ANPC
          </a>
        </div>

        {/* ANPC & SOL Badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 mb-8" data-id="element-104">
          <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="block" data-id="element-105">
            <img src="https://cdn.magicpatterns.com/uploads/oRrkUd1ZK1CKQWakKm15eQ/ANPC.webp" alt="ANPC - Soluționarea Alternativă a Litigiilor" className="h-12 md:h-14 rounded bg-white px-2 py-1" data-id="element-106" />
          </a>
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="block" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/oPz96XQHj1xjdDRUJefi2t/Solutionarea_Online_a_Litigiilor.jpg" alt="Soluționarea Online a Litigiilor" className="h-12 md:h-14 rounded bg-white px-2 py-1" data-id="element-108" />
          </a>
        </div>

        <div className="w-full h-[1px] bg-cream/10 mb-6" data-id="element-109"></div>

        <p className="text-center text-cream/40 text-xs font-inter" data-id="element-110">
          &copy; {currentYear} Lucuța Stela PFA. Toate drepturile rezervate.
        </p>
      </div>
    </footer>;
}